<div class="notification-dialog">

    <div class="notify-container">
        <div class="notify-header">
            <h6 class="notify-title">{{ ("menu.notifications.text" | translate)}}</h6>
            <button [disabled]="isAllRead()" (click)="markAllAsRead()" class="notify-action">{{ ("menu.notifications.markAllAsRead" | translate)}}</button>
        </div>
        <div class="notify-body">

            @if (!loadingNotifications && notifications?.length ) {

              <ul class="notification-list">

                @for (item of notifications ; track $index) {

                <li class="notification-list-item" (click)="navigateToPostPage(item)">
                    <div class="user-img">

                        @if (item?.userPictureUrl && item?.userPictureUrl?.trim() !== '') {
                        <img [src]="item?.userPictureUrl" alt="">

                        } @else if(item?.displayName && item?.displayName?.trim() !== '') {

                        <div class="empty-user-img">{{ item?.displayName | textAvatar }}</div>

                        }

                        <div class="notify-action-type">

                            @if (item.actionType === 'comment') {
                            <div class="icon comment">
                                <svg>
                                    <use xlink:href="#notifyMessageIcon"></use>
                                </svg>
                            </div>
                            }
                            @if (item.actionType === 'reply') {
                            <div class="icon reply">
                                <svg>
                                    <use xlink:href="#notifyShareIcon"></use>

                                </svg>
                            </div>
                            }
                            @if (item.actionType === 'like') {
                            <div class="icon like">
                                <svg>
                                    <use xlink:href="#notifyLoveIcon"></use>
                                </svg>
                            </div>
                            }


                        </div>

                    </div>
                    <div class="notification-content">

                        <div class="notification-text">
                            <div class="text">
                                <span class="user-name">{{item?.displayName}}</span>
                                @if (item.actionType === 'comment') {
                                {{("menu.notifications.commentedOnYour" | translate)}}
                                }
                                @if (item.actionType === 'reply') {
                                  {{("menu.notifications.repliedToYour" | translate)}}
                                }
                                @if (item.actionType === 'like') {
                                  {{("menu.notifications.likesYour" | translate)}}
                                }
                                {{item.text}}
                            </div>
                            <span class="notify-time">{{item.createdAt | timeAgo}}</span>
                        </div>

                        @if (item.read === false) {
                        <div class="state">
                            <svg>
                                <use xlink:href="#markAsReadIcon"></use>
                            </svg>
                        </div>
                        }
                    </div>
                </li>
                }

                <infinite-scroll
                  [loading]="isLoading"
                  [hasMore]="hasMore"
                  [postsLength]="notifications.length"
                  (loadMore)="loadMoreNotifications(notifications)"
                  [listType]="'Notifications'"
                />

              </ul>

            } @else if (loadingNotifications) {

              <div class="notify-spinner">
                <mat-spinner></mat-spinner>
              </div>

            }
            @else {
              <div class="empty-notification-state">
                  <img [src]="emptyNotifyImgUrl" alt="">
                  <h6>{{("menu.notifications.emptyNotificationState.title" | translate)}}</h6>
                  <p>
                    {{ ("menu.notifications.emptyNotificationState.body" | translate)}}
                  </p>
              </div>
            }


        </div>
    </div>
</div>
